import { window } from "global";
import React, { useEffect } from "react";
import { ReactComponent as FullUggLogo } from "../../../svg/logos/ugg-logo-blue.svg";
import Searchbar from "components/Searchbar";
import { ReactComponent as LolLogo } from "svg/League-SelectorLogo.svg";
import { ReactComponent as WowLogo } from "svg/WoW-SelectorLogo.svg";
import { ReactComponent as ValorantLogo } from "svg/valorant-logo.svg";
import GameButton from "./GameButton";
import PromoButton from "./PromoButton";
import SideNav from "../../SideNav";
import { Helmet } from "react-helmet-async";
import { ReactComponent as RaidIcon } from "svg/wow-skull-head.svg";
import { ReactComponent as ClassAndSpecIcon } from "svg/wow-tier-list-icon.svg";
import { ReactComponent as PvPIcon } from "svg/wow-pvp-icon.svg";
import { ReactComponent as MythicKeyIcon } from "svg/wow-mythic-plus-key-icon.svg";

const LandingPageContainer = (props) => {
  useEffect(() => {
    window && sessionStorage.removeItem("initial_page");
  }, []);

  const games = [
    {
      logo: <LolLogo />,
      link: "/",
      id: "league",
    },
    {
      logo: <ValorantLogo />,
      link: "/val",
      id: "val",
    },
    {
      logo: <WowLogo />,
      link: "/wow/",
      id: "wow",
    },
  ];
  const promos = [
    {
      img: <MythicKeyIcon />,
      labelOne: "Mythic+",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings",
    },
    {
      img: <RaidIcon />,
      labelOne: "Raiding",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings/raid",
    },
    {
      img: <PvPIcon />,
      labelOne: "PvP",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings/pvp",
    },
    {
      img: <ClassAndSpecIcon />,
      labelOne: "Classes & Specs",
      labelTwo: "",
      link: "/wow/classes-and-specs",
    },
  ];

  let content = null;
  if (!window) {
    content = null;
  } else {
    content = (
      <React.Fragment>
        <Helmet>
          <title>U.GG: WoW Tier Lists, Rankings, Talents, Builds</title>
          <meta
            name="description"
            content="Better data for smarter insights. U.GG provides the best data-driven WoW talents, BIS gear and tier lists for all classes and specs at Raid and Mythic+."
          />
        </Helmet>
        <div className="wow-landing-page-container">
          <FullUggLogo className="ugg-landing-page-logo" />
          <Searchbar className="landing-page-search-bar-container" isLandingPage />
          <div className="game-switcher">
            {games.map((x, i) => (
              <GameButton key={i} {...x} />
            ))}
          </div>
          <div className="promos-container">
            {promos.map((x, i) => (
              <PromoButton key={i} {...x} />
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return <React.Fragment>{content}</React.Fragment>;
};

export default LandingPageContainer;
